import { render } from "./ConfidenceChip.vue?vue&type=template&id=46766d24&scoped=true"
import script from "./ConfidenceChip.vue?vue&type=script&lang=js"
export * from "./ConfidenceChip.vue?vue&type=script&lang=js"

import "./ConfidenceChip.vue?vue&type=style&index=0&id=46766d24&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-46766d24"

export default script